<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eRQ2qH/tc-custom/9781423643036.jpg?1737164465190" alt="This image is the cover for the book 101 Things To Do With Beer, 101 Things To Do With"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">101 Things To Do With Beer, 101 Things To Do With
      </h1>
      <p class="bookDescription body article font2">
        <b>Recipes that are good for what ales you—part of the million-selling cookbook series!</b><br/>  <br/> Take your love of the suds to the next level by infusing your favorite libation into breakfast, lunch, and dinner with<i> 101 Things To Do With Beer.</i> Home cooks can depend on <i>101 Things to Do with Beer</i>'s wide range of creative recipes and affordable price to add some “hop” to every meal.<br/>  <br/> Give each dish the boost of flavor it deserves: from Beer Battered Apple Fritters to Beer Simmered Chicken Tacos; Garlic Parmesan Onion Rings to Chocolate Stout Ice Cream, you’ll satisfy even the most skeptical guest. Raise your plate and say “Cheers!”<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eliza Cross
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3112ddc4